import React, { useEffect, useState } from 'react';
import { useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Colors } from "../../../../helpers/Color";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import { IoCloseCircle, IoMdCloudUpload } from "react-icons/all";
import CustomToast from "../../../../helpers/Toast";
import FullScreenProgress from "../../../../helpers/FullScreenProgress";
import ImageUploading from "react-images-uploading";
import connection from 'components/app/auth/api';

const EditCategory = () => {

    const is430pxBelow = useMediaQuery('(max-width:430px)')
    const is770pxBelow = useMediaQuery('(max-width:770px)')

    console.log(Colors.light, "asasasa");

    const useStyles = makeStyles(() => ({
        container: {
            '& h5': {
                color: Colors.primary,
                fontSize: '20px'
            },
            '& .input-container': {
                display: 'flex',
                margin: '20px 0',
                flexDirection: 'column',
                '& .text-field': {
                    '& h6': {
                        color: Colors.darkText,
                        fontSize: '16px',
                        margin: '5px 0'
                    },
                    '& input': {
                        border: `1px solid ${Colors.primary}`,
                        '&:focus': {
                            outline: 0
                        },
                        width: is430pxBelow ? '100%' : '50%',
                        borderRadius: '5px',
                        padding: '5px 10px',
                        margin: '5px 0'
                    }
                },

                '& .select-container': {
                    width: is430pxBelow ? '100%' : '35%',
                    margin: is430pxBelow ? '15px 0 15px' : '15px 25px 5px 0',
                    '& h6': {
                        margin: '0 0 8px',
                        fontSize: '14px',
                        color: Colors.darkText
                    },
                    '& select': {
                        width: '100%',
                        border: `1px solid ${Colors.primary}`,
                        padding: '8px',
                        '&:focus': {
                            outline: 0
                        },
                        borderRadius: '5px',
                    },
                },
                '& .upload-logo': {
                    padding: is770pxBelow ? '2px 6px 4px' : '4px 8px 6px',
                    margin: '15px 0',
                    borderRadius: '5px',
                    display: 'flex',
                    alignSelf: 'flex-start',
                    cursor: 'pointer',
                    alignItems: 'center',
                    transition: 'all .4s',
                    '&:hover': {
                        background: Colors.light,
                        color: Colors.primary,
                        transition: 'all .4s',
                        border: `2px solid ${Colors.primary}`,
                        '& .top-icon': {
                            color: Colors.primary
                        },
                        '& h6': {
                            color: Colors.primary
                        }
                    },
                    '& .top-icon': {
                        color: Colors.light
                    },
                    background: Colors.primary,
                    border: `2px solid ${Colors.primary}`,
                    '& input': {
                        display: 'none'
                    },
                    '& label': {
                        margin: 0,
                        cursor: 'pointer',
                        '& h6': {
                            margin: '0 0 0 7px',
                            fontSize: is770pxBelow ? '10px' : '12px',
                            color: Colors.light,
                        }
                    },
                },
                '& .logo-container': {
                    height: '100px',
                    width: '100px',
                    border: `1px solid ${Colors.lightBorder}`,
                    borderRadius: '100px',
                    margin: '0 10px',
                    background: "#2086CF",
                    padding: '15px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '& img': {
                        maxHeight: '100%',
                        maxWidth: '100%'
                    }
                },
            },
            '& .upload': {
                width: is430pxBelow ? '100%' : '50%',
                background: Colors.primary,
                padding: '8px',
                marginTop: is770pxBelow ? '80px' : '60px',
                textAlign: 'center',
                borderRadius: '5px',
                color: Colors.light,
                border: `2px solid ${Colors.primary}`,
                transition: 'all .4s',
                fontWeight: 'bold',
                cursor: 'pointer',
                '&:hover': {
                    background: Colors.light,
                    color: Colors.primary,
                    transition: 'all .4s',
                    border: `2px solid ${Colors.primary}`,
                },
            },
            '& .gallery': {
                display: 'flex',
                flexWrap: 'wrap',
                '& .gallery-container': {
                    border: `1px solid ${Colors.lightBorder}`,
                    borderRadius: '5px',
                    position: 'relative',
                    margin: '20px 10px 0',
                    height: '100px',
                    width: '100px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '& .update-delete': {
                        position: 'absolute',
                        display: 'flex',
                        top: -10,
                        right: -10,
                        '& .delete': {
                            fontSize: '18px',
                            color: Colors.error,
                            margin: '0 3px'
                        },
                        '& .update': {
                            fontSize: '18px',
                            color: Colors.primary,
                            margin: '0 3px'
                        },
                    },
                    '& img': {
                        maxHeight: '100%',
                        maxWidth: '100%'
                    }
                }
            },
            '& .upload-gallery': {
                padding: is770pxBelow ? '2px 6px 4px' : '4px 8px 6px',
                margin: '15px 0',
                borderRadius: '5px',
                display: 'flex',
                cursor: 'pointer',
                width: '150px',
                alignItems: 'center',
                justifyContent: 'flex-start',
                transition: 'all .4s',
                '&:hover': {
                    background: Colors.light,
                    color: Colors.secondary,
                    transition: 'all .4s',
                    border: `2px solid ${Colors.secondary}`,
                    '& .top-icon': {
                        color: Colors.secondary
                    },
                    '& h6': {
                        color: Colors.secondary
                    }
                },
                '& .top-icon': {
                    color: Colors.light
                },
                background: Colors.secondary,
                border: `2px solid ${Colors.secondary}`,
                '& input': {
                    display: 'none'
                },
                '& label': {
                    margin: 0,
                    cursor: 'pointer',
                    '& h6': {
                        margin: '0 0 0 7px',
                        fontSize: is770pxBelow ? '10px' : '12px',
                        color: Colors.light
                    }
                },
            },
        }
    }))

    const classes = useStyles();
    const { id } = useParams()

    const [category, setCategory] = useState(null);

    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [open, setOpen] = useState(true);
    const [logoUrl, setLogoUrl] = useState(null)
    const [galleryImageUrl, setGalleryImageUrl] = useState([])
    const [groups, setGroups] = useState([])



    useEffect(() => {
        connection.get(`/get/generalCategory?id=${id}`).then(res => {
            setCategory({ banners: [], ...res.data.data })
            console.log(res.data.data, "res.data.data");
            setGalleryImageUrl(res.data.data?.bannerUrls)
            setLogoUrl(res.data.data?.logoUrl?.url)
            setOpen(false)
        })
    }, [id])

    const handleDataChange = (e) => {
        setCategory({ ...category, [e.target.name]: e.target.value })
    }

    const onUploadLogoClick = (e) => {
        setOpen(true)
        let formData = new FormData()
        formData.append('media', e.target.files[0])
        connection.post(`/post/fileUpload`, formData)
            .then((res) => {
                setCategory({ ...category, logo: res?.data.id });
                setLogoUrl(res?.data?.url)
                setOpen(false)
            })
    }

    const [bannerImageUrl, setBannerImageUrl] = useState(null);

    const history = useHistory();

    const [isLogoChanged, setIsLogoChanged] = useState(false)


    let galleryImg = []

    useEffect(() => {
        connection.get('/get/groups?limit=250').then(res => {
            setGroups(res?.data?.data)
        })
    }, [])

    const onUpdateClick = () => {
        const { _id, name, description, logo, banners, parentGroup, } = category
        if (name !== '' && description !== '' && logo !== null && banners.length !== 0, parentGroup != null) {
            setOpen(true)
            // const isBannerChanged = banners.length !== 0
            // const data = new FormData()
            // if (isLogoChanged) {
            //     data.append('logo', logo)
            // }
            // if (isBannerChanged) {
            //     banners.forEach(banner => {
            //         data.append('banners', banner)
            //     })
            // }
            let params = {
                data: {
                    name,
                    description,
                    logoUrl: logo,
                    bannerUrls: banners,
                    parentGroup,
                    _id

                }
            }

            // data.append('data', JSON.stringify({ _id, name, description, logoUrl: category.logoUrl }))
            // data.append('isLogoChanged', isLogoChanged.toString())
            // data.append('isBannerChanged', isBannerChanged.toString())
            connection.put('/update/generalCategory', params).then(res => {
                if (res.data.key === 'success') {
                    setOpen(false)
                    history.goBack()
                } else {
                    setOpen(false)
                    setErrorMessage('Something went wrong')
                    setOpenError(true)
                }
            })
        } else {
            setOpen(false)
            setErrorMessage('Fields should not be Empty')
            setOpenError(true)
        }
    }

    const onChange = (imageList) => {
        // const tempArr = [];
        // imageList.forEach(data => {
        //     tempArr.push(data.file);
        // });
        // setBannerImageUrl(imageList)
        // setCategory({ ...category, banners: tempArr });
        setOpen(true)
        const tempArr = [];
        imageList.forEach(data => {
            tempArr.push(data.file);
        });
        let formData = new FormData()
        tempArr.length > 0 && tempArr?.map((val) => {
            formData.append('media', val)
        })

        connection.post(`/post/fileUpload`, formData)
            .then((res) => {
                galleryImg = galleryImageUrl
                galleryImg.push(res?.data)
                setGalleryImageUrl([...galleryImg])
                setCategory({ ...category, banners: [...galleryImg]?.map((data) => data?.id) });
                setOpen(false)
            })
    };

    const onRemoveImageClick = (image) => {
        //if (category.bannerUrls.length !== 1){
        setOpen(true)
        connection.delete('/delete/generalCategoryBannerImage', { data: { categoryId: category._id, bannerImage: image } }).then(res => {
            if (res.data.key === 'success') {
                connection.get(`/get/generalCategory?id=${id}`).then(res => {
                    setCategory(res.data.data)
                    setOpen(false)
                })
            } else {
                console.log(res.data.data)
                setOpen(false)
            }
        })
        //}
    }



    return (
        <div className={classes.container}>
            <h5>Edit General Category Information</h5>
            <div className={'input-container'}>
                <div className={'text-field'}>
                    <h6>Name</h6>
                    <input value={category?.name} name={'name'} onChange={handleDataChange} />
                </div>
                <div className={'text-field'}>
                    <h6>Description</h6>
                    <input value={category?.description} name={'description'} onChange={handleDataChange} />
                </div>
                <div className={classes.container}>
                    <div className={'input-container'} style={{ display: 'flex', }}>

                        <div className={'select-container'}>
                            <h6>Group</h6>
                            <select name={'parentCategory'} value={category?.parentGroup} onChange={(e) => setCategory({ ...category, parentGroup: e.target.value })} >
                                <option value="" disabled selected>Groups</option>
                                {
                                    groups.map((pCOptions, index) => (
                                        <option key={index} value={pCOptions?.name}>{pCOptions?.name}</option>
                                    ))
                                }
                            </select>
                        </div>
                    </div>
                </div>
                <div className={'upload-logo'}>
                    <IoMdCloudUpload className={'top-icon'} fontSize={19} />
                    <div>
                        <label htmlFor={'logo-picker'}><h6>UPLOAD THUMBNAIL</h6></label>
                        <input id={'logo-picker'} type={'file'} size={'60'}
                            accept={'image/*'}
                            multiple={false}
                            onChange={onUploadLogoClick} />
                    </div>
                </div>
                {

                    logoUrl !== null ?
                        <div className={'logo-container'}>
                            <img alt={'logo'} src={logoUrl} />
                        </div> : <></>


                }
                <ImageUploading
                    multiple
                    value={galleryImageUrl}
                    onChange={onChange}
                    maxNumber={6}
                    dataURLKey="data_url"
                >
                    {({
                        imageList,
                        onImageUpload,
                        dragProps,
                    }) => (
                        <div>
                            <div className={'upload-gallery'} onClick={onImageUpload} {...dragProps}>
                                <IoMdCloudUpload className={'top-icon'} fontSize={19} />
                                <div>
                                    <label><h6>UPLOAD BANNERS</h6></label>
                                </div>
                            </div>
                            <div className={'gallery'}>
                                {imageList.map((image, index) => (
                                    <div key={index} className={'gallery-container'}>
                                        <img alt={'Thumbnail'} src={image['url']} />
                                        <div className={'update-delete'}>
                                            {/*<BsArrowRepeat onClick={() => onImageUpdate(index)} className={'update'}/>*/}
                                            <IoCloseCircle onClick={() => { setGalleryImageUrl(galleryImageUrl.filter(val => val.id !== image?.id)); }} className={'delete'} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </ImageUploading>

            </div>
            <div className={'upload'} onClick={onUpdateClick}>
                Update
            </div>
            <CustomToast type={'error'} openToast={openError} setOpenToast={setOpenError} message={errorMessage} />
            <FullScreenProgress open={open} setOpen={setOpen} />

        </div>
    );


};

export default EditCategory;
